import { h } from 'preact';
import { Table } from '../Table';
import { Badge } from '../Badge';
import { Button } from '../Button';
import type { ComponentShowcase } from '../registry';
import { T } from '../../../styles/tokens';

export const showcase: ComponentShowcase = {
  name: 'Table',
  category: '📊 Data Display',
  description: 'Tabela com colunas, render customizado, loading state e ordenação',
  usedIn: ['Integrations', 'AgentesPage', 'ReferralDashboard'],
  example: () => (
    <div>
      <Table
        columns={[
          { key: 'nome', label: 'Nome' },
          { key: 'status', label: 'Status', render: (v: string) => <Badge variant={v === 'Ativo' ? 'success' : v === 'Pendente' ? 'warning' : 'error'}>{v}</Badge> },
          { key: 'acoes', label: 'Ações', render: () => <Button size="xs" variant="ghost">Editar</Button> },
        ]}
        data={[
          { nome: 'Gustavo Lemos', status: 'Ativo', acoes: '' },
          { nome: 'Maria Silva', status: 'Pendente', acoes: '' },
          { nome: 'Carlos Souza', status: 'Inativo', acoes: '' },
        ]}
      />
      <div style={{ marginTop: 16 }}>
        <div style={{ fontSize: 12, color: T.textMuted, marginBottom: 8 }}>Com loading=true:</div>
        <Table
          columns={[
            { key: 'nome', label: 'Nome' },
            { key: 'status', label: 'Status' },
          ]}
          data={[]}
          loading={true}
        />
      </div>
    </div>
  ),
};
